import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-boleto-success',
  templateUrl: './boleto-success.component.html',
  styleUrls: ['./boleto-success.component.css']
})
export class BoletoSuccessComponent {

  data: any;

  constructor(
    private router: Router
  ) {
    const nav = this.router.getCurrentNavigation();
    this.data = nav.extras.state.data;
  }

  emitirBoletos() {
    this.router.navigate(['boletos', 'emitir']);
  }

}
